import React from 'react';
import { useContext } from 'react';
import { CantiqueContextAPI } from '../Context/CantiqueContext';

const DuplicateModal = () => {
  const { duplicateCantique, setDuplicateCantique } = useContext(CantiqueContextAPI);

  if (!duplicateCantique) return null;

  const handleClose = () => {
    setDuplicateCantique(null);
  };

  return (
    <div className="duplicate-modal-overlay">
      <div className="duplicate-modal">
        <p>Ce cantique existe déjà. Il s'agit du numéro {duplicateCantique.number}.</p>
        <button onClick={handleClose}>Fermer</button>
      </div>
    </div>
  );
};

export default DuplicateModal;